import React from "react";

export function PageContainer({ overline, title, subtitle, children, actions, wide = false }) {
  return (
    <div className="h-full overflow-y-auto">
      <div className={`${wide ? "max-w-7xl" : "max-w-5xl"} mx-auto px-6 lg:px-10 py-10`}>
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            {overline && (
              <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#73bf44] mb-2">{overline}</div>
            )}
            <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tighter text-white">{title}</h1>
            {subtitle && <p className="text-neutral-400 mt-2 max-w-2xl">{subtitle}</p>}
          </div>
          {actions}
        </div>
        {children}
      </div>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 border border-dashed border-neutral-800 rounded-2xl">
      {Icon && <Icon size={40} className="text-neutral-700 mb-4" weight="duotone" />}
      <div className="text-neutral-300 font-medium">{title}</div>
      {hint && <div className="text-sm text-neutral-600 mt-1 max-w-sm">{hint}</div>}
    </div>
  );
}
